import { GlobalAxios } from "../axios/axios-config";
import { IProcedureGroup } from "../models/procedure-group";

const PROCEDURE_GROUP_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/ProcedureGroup";

export const procedureGroupList = (params?: any) => {
  return GlobalAxios.get<IProcedureGroup[]>(PROCEDURE_GROUP_ROUTE, {
    params,
  });
};
